import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { Progress } from '@backstage/core-components';
import { useCanAccessPsAgent } from './useCanAccessPsAgent';

/** Gate /agent for Professional Services members (and admins). */
export const RequirePsAgentAccess = ({ children }: PropsWithChildren) => {
  const canAccess = useCanAccessPsAgent();

  if (canAccess === undefined) {
    return <Progress />;
  }

  if (!canAccess) {
    return <Navigate to="/catalog" replace />;
  }

  return <>{children}</>;
};
